import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';

const thunks = {
  createInvoice: createThunk('createInvoice/create', (data) =>
    api.post(WEB_API_ROUTES.invoices.list, data)
  ),
  createInvoiceItem: createThunk(
    'createInvoice/createInvoiceItem',
    ({ data, editInvoiceId }) =>
      api.post(
        WEB_API_ROUTES.invoices.items.replace('{invoiceId}', editInvoiceId),
        data
      )
  ),
  getInvoice: createThunk('createInvoice/getInvoice', (invoiceId) =>
    api.get(WEB_API_ROUTES.invoices.items.replace('{invoiceId}', invoiceId))
  ),
  editInvoiceItem: createThunk(
    'createInvoice/editInvoiceItem',
    ({ editInvoiceId, itemId, data }) =>
      api.put(
        WEB_API_ROUTES.invoices.item
          .replace('{invoiceId}', editInvoiceId)
          .replace('{itemId}', itemId),
        data
      )
  ),
  editInvoice: createThunk(
    'createInvoice/editInvoice',
    ({ data, editInvoiceId }) =>
      api.post(
        WEB_API_ROUTES.invoices.edit.replace('{invoiceId}', editInvoiceId),
        data
      )
  ),
  draftInvoice: createThunk(
    'createInvoice/editInvoice',
    ({ data, editInvoiceId }) =>
      api.put(
        WEB_API_ROUTES.invoices.info.replace('{invoiceId}', editInvoiceId),
        data
      )
  ),
  removeInvoiceItem: createThunk(
    'createInvoice/removeInvoiceItem',
    ({ editInvoiceId, itemId }) =>
      api.delete(
        WEB_API_ROUTES.invoices.item
          .replace('{invoiceId}', editInvoiceId)
          .replace('{itemId}', itemId)
      )
  ),
  getInvoiceItems: createThunk(
    'createInvoice/getInvoiceItems',
    (editInvoiceId) =>
      api.get(
        WEB_API_ROUTES.invoices.items.replace('{invoiceId}', editInvoiceId)
      )
  ),
  customerSearch: createThunk('createInvoice/customerSearch', ({ query }) =>
    api.get(WEB_API_ROUTES.invoices.customerSearch, {
      params: { query },
    })
  ),
  itemSearch: createThunk(
    'createInvoice/itemSearch',
    ({ query, customerId, customerType }) =>
      api.get(WEB_API_ROUTES.invoices.itemsSearch, {
        params: {
          query,
          customerId,
          customerType,
        },
      })
  ),
};

export { thunks };
